// extracted by mini-css-extract-plugin
module.exports = {"shift":"Shift_shift__2_BwB","shift_moderable":"Shift_shift_moderable__3umq8","delete":"Shift_delete__3xv3Y"};